<template>
    <CollapsibleCardBase>
        <template #title>
            <div class="mt-1 font-bold text-sm">
                {{ $t('component.missionProfile.details.title') }}
            </div>
        </template>
        <template #content>
            <div class="text-sm leading-tight text-gray-600">
                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $tc('text.patient', 1) }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <MissionDetailGender :gender="patient.gender"></MissionDetailGender>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_speak') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_speak"></PatientCapabilityState>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_hear') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_hear"></PatientCapabilityState>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_see') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_see"></PatientCapabilityState>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_get_on_off_bed') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_get_on_off_bed"></PatientCapabilityState>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_stand') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_stand"></PatientCapabilityState>
                    </div>
                </div>

                <div class="w-full flex">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.can_walk') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <PatientCapabilityState class="ml-1" :state="patient.capabilities.can_walk"></PatientCapabilityState>
                    </div>
                </div>
            </div>
        </template>
    </CollapsibleCardBase>
</template>

<script>
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    import MissionDetailGender from "@/components/missions/MissionDetailGender";
    import PatientCapabilityState from "@/components/missions/PatientCapabilityState";

    export default {
        name: "MissionProfileDetails",
        props: ['missionDetail'],
        components: {PatientCapabilityState, CollapsibleCardBase, MissionDetailGender }
    }
</script>

<style scoped>

</style>